<template>
  <div class="c-info">
    <p>
      <img src="../assets/images/GRAFIKA-NA-STRONE_1902x302_v3.jpg" alt="Wyjątkowa oferta na wszystkie modele Audi z rocznika 2018" class="img-responsive">
    </p>
    <p>
      Wyjątkowa oferta na wszystkie modele Audi z rocznika 2018 dostępne <strong>w specjalnych cenach z korzyścią do 23%, rekompensującą zmiany podatkowe w leasingu*.</strong> Oferta łączy się z promocyjnym finansowaniem <strong>Audi Classic Leasing 101%, 103%, 105%.</strong>
    </p>
    <p>
        Alternatywnie do cen specjalnych możesz skorzystać z innowacyjnego finansowania Audi Perfect Lease.
    </p>
    <p>
      Wybrane modele: Audi A6, Audi A7, Audi Q7 i Audi Q8 dostępne z <strong>0% opłaty wstępnej. </strong>
    </p>
    <p>
      Prezentowane poniżej ceny specjalne brutto uwzględniają rekomendowane korzyści dla modeli z rocznika 2018.
    </p>
    <p>
      Znajdź swoje Audi, wypełnij i wyślij formularz kontaktowy. Zadzwonimy do Ciebie, aby przygotować ofertę na wybrany samochód.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Info'
}
</script>
<style lang="scss">
  .img-responsive{
    width: 100%;
    height: auto;
  }
  .c-info{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    // padding-bottom: 2rem;
    strong{
      font-family: 'AudiType';
    }
    h2{
      margin-top:2rem;
      font-size: 1.9rem;
      margin-bottom: 3rem;
      @media(max-width: 960px){
        margin-top:1.5rem;
        font-size: 1.2rem;
        margin-bottom: 2rem;
      }
    }
    ul{
      list-style-type: none;
      padding: 0px;
      li{
        font-size: 1.4rem;
        line-height: 2.4rem;
        @media(max-width: 960px){
          font-size: .9rem;
          line-height: 2rem;
        }
      }
    }
    p{
      font-size: 1.22rem;
      line-height: 1.8rem;
      @media(max-width: 960px){
        font-size: .9rem;
        line-height: 2rem;
      }
    }
  }
</style>
